import { API_BASE_URL } from "./advancedSettings";

export interface StreamInfo {
  name: string;
  imageUrl: string;
  color: string;
}

/** Remembers which of an account's streams the portal is showing, per account, in this browser. */
export const selectedStreamKey = (uid: string) => `selected_stream:${uid}`;

/**
 * The account's streams from the API (oldest first), read with the login token. The API is the source of truth because it is
 * what counts them against the account's limit. Throws when the API does not answer, so the caller can fall back.
 */
export async function fetchMyStreams(getToken: () => Promise<string>, fetchFn: typeof fetch = fetch): Promise<StreamInfo[]> {
  const response = await fetchFn(`${API_BASE_URL}/streamdesign/Mine`, {
    headers: { Authorization: `Bearer ${await getToken()}` },
  });
  if (!response.ok) throw new Error(`Loading your streams failed (${response.status})`);
  const rows: { streamName: string; streamColor?: string; logoUrl?: string }[] = await response.json();
  return rows.map((r) => ({ name: r.streamName, imageUrl: r.logoUrl || "", color: r.streamColor || "" }));
}

/**
 * Which stream to show: the one the person picked last if they still have it, else the account's original stream (the one on
 * its profile), else the oldest.
 */
export function pickSelected(streams: StreamInfo[], saved: string | null, primaryName: string | null): StreamInfo | null {
  const find = (name: string | null) => (name ? streams.find((s) => s.name.toLowerCase() === name.toLowerCase()) : undefined);
  return find(saved) ?? find(primaryName) ?? streams[0] ?? null;
}
